import { Language } from '@/contexts/LanguageContext';

type TranslationDictionary = Record<string, string>;
type Translations = Record<Language, TranslationDictionary>;

export const translations: Translations = {
  he: {
    // Navbar
    navProduct: 'המוצר',
    navPricing: 'תמחור',
    navDemo: 'הדגמה',
    navLogin: 'התחברות',
    navSignup: 'הרשמה',
    
    // Hero Section
    heroTitle: 'לוח הודעות דיגיטלי לבית הכנסת',
    heroSubtitle: 'פתרון מושלם להצגת לוח זמנים, פרשת שבוע, ואירועים לקהילה שלך',
    heroButton: 'התחל עכשיו',
    
    // Features
    featuresTitle: 'תכונות מובילות',
    featureTimeTitle: 'זמני תפילה דינמיים',
    featureTimeDesc: 'הצגה אוטומטית של זמני תפילה על פי התאריך העברי',
    featureDateTitle: 'לוח שנה עברי',
    featureDateDesc: 'הצגת התאריך העברי והחגים הקרובים',
    featureContentTitle: 'תוכן מותאם אישית',
    featureContentDesc: 'שליטה מלאה בכל הפריטים המוצגים',
    featureMobileTitle: 'ניהול מהנייד',
    featureMobileDesc: 'עדכון התוכן מכל מכשיר ומכל מקום',
    
    // How it works
    howTitle: 'איך זה עובד',
    howStep1: 'יצירת חשבון',
    howStep2: 'התאמת הלוח הדיגיטלי',
    howStep3: 'העלאת התוכן שלך',
    howStep4: 'הצגת הלוח במסך בבית הכנסת',
    
    // Pricing
    pricingTitle: 'תוכניות מחירים',
    pricingSubtitle: 'בחרו את התוכנית המתאימה לצרכים שלכם',
    pricingBasic: 'בסיסי',
    pricingStandard: 'סטנדרט',
    pricingPremium: 'פרימיום',
    pricingMonthly: 'חודשי',
    pricingAnnual: 'שנתי',
    pricingFeature1: 'לוח זמנים דינמי',
    pricingFeature2: 'לוח שנה עברי',
    pricingFeature3: 'פרשת שבוע',
    pricingFeature4: 'תמיכה טכנית',
    pricingFeature5: 'רכיבים מותאמים אישית',
    pricingFeature6: 'אינטגרציה עם אפליקציות אחרות',
    pricingButton: 'התחל עכשיו',
    
    // Testimonials
    testimonialsTitle: 'מה אומרים עלינו',
    testimonialText1: 'החלפנו את לוח המודעות המיושן שלנו בלוח הדיגיטלי והקהילה פשוט מרוצה. זה חסך לנו זמן רב בעדכון המידע.',
    testimonialAuthor1: 'הרב יעקב לוי, בית הכנסת המרכזי',
    testimonialText2: 'המערכת קלה לשימוש ומאפשרת לנו להציג את כל המידע הדרוש לקהילה בצורה מסודרת ונעימה.',
    testimonialAuthor2: 'שמואל כהן, גבאי',
    testimonialText3: 'ההתקנה הייתה פשוטה והתמיכה הטכנית מעולה. מומלץ בחום לכל בית כנסת!',
    testimonialAuthor3: 'דוד מזרחי, מנהל קהילה',
    testimonialText4: 'הלוח הדיגיטלי הפך למוקד משיכה בקהילה שלנו. המתפללים נהנים מהמידע העדכני.',
    testimonialAuthor4: 'יוסף אברהם, רב קהילה',
    
    // Demo
    demoTitle: 'צפו בהדגמה',
    demoDescription: 'לוח דיגיטלי אינטראקטיבי לדוגמה',
    
    // FAQ
    faqTitle: 'שאלות נפוצות',
    faqQuestion1: 'איך מתקינים את הלוח הדיגיטלי?',
    faqAnswer1: 'ההתקנה פשוטה מאוד. כל שצריך הוא מסך (טלוויזיה או מוניטור) וחיבור לאינטרנט. ניתן להציג את הלוח דרך דפדפן או באמצעות נגן מדיה ייעודי.',
    faqQuestion2: 'האם ניתן להתאים אישית את העיצוב?',
    faqAnswer2: 'בהחלט! המערכת מציעה מגוון תבניות עיצוב והתאמות, כולל צבעים, פונטים וסגנונות שונים המתאימים לאופי בית הכנסת.',
    faqQuestion3: 'איך מעדכנים את התוכן?',
    faqAnswer3: 'עדכון התוכן נעשה דרך ממשק ניהול פשוט וידידותי, הנגיש מכל מכשיר (מחשב, טאבלט או סמארטפון). אין צורך בידע טכני מיוחד.',
    
    // CTA
    ctaTitle: 'מוכנים להתחיל?',
    ctaSubtitle: 'הצטרפו למאות בתי כנסת שכבר נהנים מהלוח הדיגיטלי',
    ctaButton: 'צור חשבון',
    
    // Footer
    footerRights: 'כל הזכויות שמורות',
    footerSupport: 'תמיכה',
    footerPrivacy: 'מדיניות פרטיות',
    footerTerms: 'תנאי שימוש',
  },
  
  en: {
    // Navbar
    navProduct: 'Product',
    navPricing: 'Pricing',
    navDemo: 'Demo',
    navLogin: 'Login',
    navSignup: 'Sign Up',
    
    // Hero Section
    heroTitle: 'Digital Display Board for Synagogues',
    heroSubtitle: 'The perfect solution for displaying schedules, weekly parsha, and events for your community',
    heroButton: 'Get Started',
    
    // Features
    featuresTitle: 'Key Features',
    featureTimeTitle: 'Dynamic Prayer Times',
    featureTimeDesc: 'Automatically display prayer times based on the Hebrew date',
    featureDateTitle: 'Hebrew Calendar',
    featureDateDesc: 'Display the Hebrew date and upcoming holidays',
    featureContentTitle: 'Custom Content',
    featureContentDesc: 'Full control over all displayed items',
    featureMobileTitle: 'Mobile Management',
    featureMobileDesc: 'Update content from any device, anywhere',
    
    // How it works
    howTitle: 'How It Works',
    howStep1: 'Create an account',
    howStep2: 'Customize your digital board',
    howStep3: 'Upload your content',
    howStep4: 'Display the board on a screen in your synagogue',
    
    // Pricing
    pricingTitle: 'Pricing Plans',
    pricingSubtitle: 'Choose the plan that fits your needs',
    pricingBasic: 'Basic',
    pricingStandard: 'Standard',
    pricingPremium: 'Premium',
    pricingMonthly: 'Monthly',
    pricingAnnual: 'Annual',
    pricingFeature1: 'Dynamic Schedule',
    pricingFeature2: 'Hebrew Calendar',
    pricingFeature3: 'Weekly Parsha',
    pricingFeature4: 'Technical Support',
    pricingFeature5: 'Custom Widgets',
    pricingFeature6: 'Integrations',
    pricingButton: 'Get Started',
    
    // Testimonials
    testimonialsTitle: 'What People Say',
    testimonialText1: 'We replaced our outdated notice board with the digital display, and the community is simply delighted. It has saved us a lot of time updating information.',
    testimonialAuthor1: 'Rabbi Jacob Levy, Central Synagogue',
    testimonialText2: 'The system is easy to use and allows us to display all the necessary information for the community in an organized and pleasant way.',
    testimonialAuthor2: 'Samuel Cohen, Gabbai',
    testimonialText3: 'The installation was simple and the technical support is excellent. Highly recommended for any synagogue!',
    testimonialAuthor3: 'David Mizrahi, Community Manager',
    testimonialText4: 'The digital board has become a focal point in our community. Congregants enjoy the up-to-date information.',
    testimonialAuthor4: 'Joseph Abraham, Community Rabbi',
    
    // Demo
    demoTitle: 'Watch the Demo',
    demoDescription: 'Interactive digital board example',
    
    // FAQ
    faqTitle: 'Frequently Asked Questions',
    faqQuestion1: 'How do you install the digital board?',
    faqAnswer1: 'Installation is very simple. All you need is a screen (TV or monitor) and an internet connection. The board can be displayed through a browser or via a dedicated media player.',
    faqQuestion2: 'Can I customize the design?',
    faqAnswer2: 'Absolutely! The system offers a variety of design templates and customizations, including colors, fonts, and different styles that match the character of your synagogue.',
    faqQuestion3: 'How do you update the content?',
    faqAnswer3: 'Content updates are done through a simple and user-friendly management interface, accessible from any device (computer, tablet, or smartphone). No special technical knowledge is required.',
    
    // CTA
    ctaTitle: 'Ready to Get Started?',
    ctaSubtitle: 'Join hundreds of synagogues already enjoying the digital display board',
    ctaButton: 'Create Account',
    
    // Footer
    footerRights: 'All Rights Reserved',
    footerSupport: 'Support',
    footerPrivacy: 'Privacy Policy',
    footerTerms: 'Terms of Use',
  },
  
  fr: {
    // Navbar
    navProduct: 'Produit',
    navPricing: 'Tarifs',
    navDemo: 'Démo',
    navLogin: 'Connexion',
    navSignup: 'Inscription',
    
    // Hero Section
    heroTitle: 'Panneau d\'Affichage Numérique pour Synagogues',
    heroSubtitle: 'La solution parfaite pour afficher les horaires, la parasha hebdomadaire et les événements pour votre communauté',
    heroButton: 'Commencer',
    
    // Features
    featuresTitle: 'Caractéristiques Principales',
    featureTimeTitle: 'Horaires de Prière Dynamiques',
    featureTimeDesc: 'Affichez automatiquement les horaires de prière en fonction de la date hébraïque',
    featureDateTitle: 'Calendrier Hébraïque',
    featureDateDesc: 'Affichez la date hébraïque et les fêtes à venir',
    featureContentTitle: 'Contenu Personnalisé',
    featureContentDesc: 'Contrôle total sur tous les éléments affichés',
    featureMobileTitle: 'Gestion Mobile',
    featureMobileDesc: 'Mettez à jour le contenu depuis n\'importe quel appareil, n\'importe où',
    
    // How it works
    howTitle: 'Comment Ça Marche',
    howStep1: 'Créez un compte',
    howStep2: 'Personnalisez votre tableau numérique',
    howStep3: 'Téléchargez votre contenu',
    howStep4: 'Affichez le tableau sur un écran dans votre synagogue',
    
    // Pricing
    pricingTitle: 'Plans Tarifaires',
    pricingSubtitle: 'Choisissez le plan qui correspond à vos besoins',
    pricingBasic: 'Basique',
    pricingStandard: 'Standard',
    pricingPremium: 'Premium',
    pricingMonthly: 'Mensuel',
    pricingAnnual: 'Annuel',
    pricingFeature1: 'Horaire Dynamique',
    pricingFeature2: 'Calendrier Hébraïque',
    pricingFeature3: 'Parasha Hebdomadaire',
    pricingFeature4: 'Support Technique',
    pricingFeature5: 'Widgets Personnalisés',
    pricingFeature6: 'Intégrations',
    pricingButton: 'Commencer',
    
    // Testimonials
    testimonialsTitle: 'Ce Qu\'ils En Disent',
    testimonialText1: 'Nous avons remplacé notre tableau d\'affichage obsolète par l\'affichage numérique, et la communauté est simplement ravie. Cela nous a fait gagner beaucoup de temps pour mettre à jour les informations.',
    testimonialAuthor1: 'Rabbin Jacob Levy, Synagogue Centrale',
    testimonialText2: 'Le système est facile à utiliser et nous permet d\'afficher toutes les informations nécessaires pour la communauté de manière organisée et agréable.',
    testimonialAuthor2: 'Samuel Cohen, Gabbaï',
    testimonialText3: 'L\'installation était simple et le support technique est excellent. Fortement recommandé pour toute synagogue !',
    testimonialAuthor3: 'David Mizrahi, Gestionnaire de Communauté',
    testimonialText4: 'Le tableau numérique est devenu un point central dans notre communauté. Les fidèles apprécient les informations à jour.',
    testimonialAuthor4: 'Joseph Abraham, Rabbin Communautaire',
    
    // Demo
    demoTitle: 'Regarder la Démo',
    demoDescription: 'Exemple de tableau numérique interactif',
    
    // FAQ
    faqTitle: 'Questions Fréquemment Posées',
    faqQuestion1: 'Comment installer le tableau numérique?',
    faqAnswer1: 'L\'installation est très simple. Tout ce dont vous avez besoin est un écran (TV ou moniteur) et une connexion Internet. Le tableau peut être affiché via un navigateur ou via un lecteur multimédia dédié.',
    faqQuestion2: 'Puis-je personnaliser le design?',
    faqAnswer2: 'Absolument! Le système offre une variété de modèles de conception et de personnalisations, y compris les couleurs, les polices et différents styles qui correspondent au caractère de votre synagogue.',
    faqQuestion3: 'Comment mettre à jour le contenu?',
    faqAnswer3: 'Les mises à jour de contenu se font via une interface de gestion simple et conviviale, accessible depuis n\'importe quel appareil (ordinateur, tablette ou smartphone). Aucune connaissance technique spéciale n\'est requise.',
    
    // CTA
    ctaTitle: 'Prêt à Commencer?',
    ctaSubtitle: 'Rejoignez des centaines de synagogues qui profitent déjà du tableau d\'affichage numérique',
    ctaButton: 'Créer un Compte',
    
    // Footer
    footerRights: 'Tous Droits Réservés',
    footerSupport: 'Support',
    footerPrivacy: 'Politique de Confidentialité',
    footerTerms: 'Conditions d\'Utilisation',
  },
  
  es: {
    // Navbar
    navProduct: 'Producto',
    navPricing: 'Precios',
    navDemo: 'Demo',
    navLogin: 'Iniciar Sesión',
    navSignup: 'Registrarse',
    
    // Hero Section
    heroTitle: 'Tablero Digital para Sinagogas',
    heroSubtitle: 'La solución perfecta para mostrar horarios, parashá semanal y eventos para tu comunidad',
    heroButton: 'Comenzar',
    
    // Features
    featuresTitle: 'Características Principales',
    featureTimeTitle: 'Horarios de Oración Dinámicos',
    featureTimeDesc: 'Muestra automáticamente los horarios de oración según la fecha hebrea',
    featureDateTitle: 'Calendario Hebreo',
    featureDateDesc: 'Muestra la fecha hebrea y las próximas festividades',
    featureContentTitle: 'Contenido Personalizado',
    featureContentDesc: 'Control total sobre todos los elementos mostrados',
    featureMobileTitle: 'Gestión Móvil',
    featureMobileDesc: 'Actualiza el contenido desde cualquier dispositivo, en cualquier lugar',
    
    // How it works
    howTitle: 'Cómo Funciona',
    howStep1: 'Crea una cuenta',
    howStep2: 'Personaliza tu tablero digital',
    howStep3: 'Sube tu contenido',
    howStep4: 'Muestra el tablero en una pantalla en tu sinagoga',
    
    // Pricing
    pricingTitle: 'Planes de Precios',
    pricingSubtitle: 'Elige el plan que se adapte a tus necesidades',
    pricingBasic: 'Básico',
    pricingStandard: 'Estándar',
    pricingPremium: 'Premium',
    pricingMonthly: 'Mensual',
    pricingAnnual: 'Anual',
    pricingFeature1: 'Horario Dinámico',
    pricingFeature2: 'Calendario Hebreo',
    pricingFeature3: 'Parashá Semanal',
    pricingFeature4: 'Soporte Técnico',
    pricingFeature5: 'Widgets Personalizados',
    pricingFeature6: 'Integraciones',
    pricingButton: 'Comenzar',
    
    // Testimonials
    testimonialsTitle: 'Lo Que Dicen',
    testimonialText1: 'Reemplazamos nuestro tablón de anuncios anticuado por la pantalla digital, y la comunidad está simplemente encantada. Nos ha ahorrado mucho tiempo actualizando información.',
    testimonialAuthor1: 'Rabino Jacob Levy, Sinagoga Central',
    testimonialText2: 'El sistema es fácil de usar y nos permite mostrar toda la información necesaria para la comunidad de manera organizada y agradable.',
    testimonialAuthor2: 'Samuel Cohen, Gabai',
    testimonialText3: 'La instalación fue simple y el soporte técnico es excelente. ¡Muy recomendable para cualquier sinagoga!',
    testimonialAuthor3: 'David Mizrahi, Gerente de Comunidad',
    testimonialText4: 'El tablero digital se ha convertido en un punto focal en nuestra comunidad. Los congregantes disfrutan de la información actualizada.',
    testimonialAuthor4: 'Joseph Abraham, Rabino Comunitario',
    
    // Demo
    demoTitle: 'Ver la Demostración',
    demoDescription: 'Ejemplo de tablero digital interactivo',
    
    // FAQ
    faqTitle: 'Preguntas Frecuentes',
    faqQuestion1: '¿Cómo se instala el tablero digital?',
    faqAnswer1: 'La instalación es muy simple. Todo lo que necesitas es una pantalla (TV o monitor) y una conexión a Internet. El tablero se puede mostrar a través de un navegador o mediante un reproductor multimedia dedicado.',
    faqQuestion2: '¿Puedo personalizar el diseño?',
    faqAnswer2: '¡Absolutamente! El sistema ofrece una variedad de plantillas de diseño y personalizaciones, incluidos colores, fuentes y diferentes estilos que coinciden con el carácter de tu sinagoga.',
    faqQuestion3: '¿Cómo se actualiza el contenido?',
    faqAnswer3: 'Las actualizaciones de contenido se realizan a través de una interfaz de gestión simple y fácil de usar, accesible desde cualquier dispositivo (ordenador, tableta o smartphone). No se requieren conocimientos técnicos especiales.',
    
    // CTA
    ctaTitle: '¿Listo para Comenzar?',
    ctaSubtitle: 'Únete a cientos de sinagogas que ya disfrutan del tablero de visualización digital',
    ctaButton: 'Crear Cuenta',
    
    // Footer
    footerRights: 'Todos los Derechos Reservados',
    footerSupport: 'Soporte',
    footerPrivacy: 'Política de Privacidad',
    footerTerms: 'Términos de Uso',
  }
}; 